// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Yr-5H","question":"styles_question__291eR","description":"styles_description__22VGX"};